// extracted by mini-css-extract-plugin
module.exports = {"progressBarWithValue":"ProgressBarWithValue_progressBarWithValue__2gk8y","valueText":"ProgressBarWithValue_valueText__1CGGS"};